import { useCallback, useContext } from "react";
import { GlobalContext } from "../contexts/GlobalContext";
import { hasPermission as hasCapability } from "../auth/permissions";

export const usePermissions = () => {
  const { globalData } = useContext(GlobalContext);
  const permissions = globalData?.permissions || [];
  const permissionsLoaded = globalData?.permissionsLoaded === true;
  const roles = globalData?.roles || [];

  const hasPermission = useCallback(
    (capabilityId, minimum = "R") => {
      if (!permissionsLoaded) {
        return true;
      }

      return hasCapability(permissions, capabilityId, minimum);
    },
    [permissions, permissionsLoaded]
  );

  return {
    permissions,
    permissionsLoaded,
    roles,
    hasPermission,
  };
};
